import WebToAppPopup from '@/components/common/web-to-app-popup'
import React, {
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef
} from 'react'

interface AppPopUpProps {
  showPopup: boolean
  setShowPopup: (value: boolean) => void
}

export interface AppPopUpHandles {
  handlePhotoClick: () => void
}

const AppPopUp = forwardRef<AppPopUpHandles, AppPopUpProps>(
  ({ showPopup, setShowPopup }, ref) => {
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
    useEffect(() => {
      const hasSeenPopup = sessionStorage.getItem('hasSeenPopup')
      if (hasSeenPopup != null) return

      const storedStartTime = Number(sessionStorage.getItem('popupTimerStart'))
      const remainingTime = 15000 - (Date.now() - storedStartTime)

      if (remainingTime <= 0 && hasSeenPopup !== 'true') {
        setShowPopup(true)
        sessionStorage.setItem('hasSeenPopup', 'true')
      } else {
        timerRef.current = setTimeout(() => {
          setShowPopup(true)
          sessionStorage.setItem('hasSeenPopup', 'true')
        }, remainingTime)
      }

      return () => {
        if (timerRef.current != null) clearTimeout(timerRef.current)
      }
    }, [setShowPopup])

    const handlePhotoClick = (): void => {
      sessionStorage.setItem('hasSeenPopup', 'true')
      sessionStorage.removeItem('popupTimerStart')
      if (timerRef.current != null) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
      setShowPopup(true)
    }

    useImperativeHandle(ref, () => ({
      handlePhotoClick
    }))

    return <WebToAppPopup isOpen={showPopup} onClose={() => { setShowPopup(false) }} />
  }
)

AppPopUp.displayName = 'AppPopUp'

export default AppPopUp
